import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHawaii = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_199)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C15.043 24 17.8209 22.8668 19.9362 21H4.06378C6.17911 22.8668 8.95702 24 12 24Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.378048 15C0.652032 16.0643 1.06856 17.0714 1.60575 18H22.3942C22.9314 17.0714 23.3479 16.0643 23.6219 15L12 14.087L0.378048 15Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.622 9C23.348 7.93566 22.9314 6.92859 22.3943 6L12 5.73914C12 3.64322 12 1.66242 12 0C11.1086 0 10.2398 0.0972656 9.40378 0.281625C9.38775 0.285187 1.5652 6.45553 1.5652 12C1.76522 12.0348 12 13.0435 12 13.0435C12 13.0435 12 10.7578 12 9H23.622Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 7.48698V1.48697H8.19961L9.40416 0.282425C4.45927 1.37302 0.659813 5.51321 0.0782812 10.6305C0.0271875 11.08 0 11.5368 0 12H6.07828V9.6083L8.49366 12H12.7867L8.19956 7.48698H12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0055 12L7.49245 7.48697H6.07828V7.48701L10.5913 12H4.5652V6H22.3942C21.7409 4.87064 20.9085 3.85795 19.9363 3H4.5652V2.58164C3.35452 3.53869 2.33302 4.72406 1.5652 6.07284V12H0C0 13.0359 0.13125 14.0412 0.378047 15H23.622C23.8687 14.0411 24 13.0359 24 12H12.0055Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_199",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgHawaii;
